var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdraw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.68 8.56a.85.85 0 001.175-1.227l-5.27-5.046a.85.85 0 00-1.175 0L4.14 7.333A.85.85 0 105.316 8.56l3.832-3.67v8.102a.85.85 0 001.7 0V4.891l3.831 3.669zM3.85 16.348a.85.85 0 000 1.7h12.295a.85.85 0 100-1.7H3.85z",
    fill: "currentColor"
  })));
}
export default SvgWithdraw;